import * as React from "react";
import {Box} from "@unibuddy/patron";

type InboxWrapperProps = {
    children: React.ReactNode;
};

export const InboxWrapper: React.FC<InboxWrapperProps> = (props) => (
    <Box borderColor="#e4e8eb" borderWidth={1} borderRadius="xxsmall" overflow="auto">
        {props.children}
    </Box>
);
